import React, { useMemo } from 'react';
import { QRCode } from '@desygner/ui-editor-menus';

import ReactAppBuilder from 'src/utils/react-app-builder';

class QRCodeView extends ReactAppBuilder {
  #defaultOptions = {
    backgroundColor: '#ffffff',
    qrCodeColor: '#000000',
    margin: 2
  };

  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp () {
    super.mountApp(this.App);
  }

  generateQRCode = (type, data, options) => {
    if (!data) {
      return;
    }

    return INKIVE.DesignFacade.create('qrcode', {
      type,
      data,
      options
    });
  };

  showProUserPaywall = () => {
    if (INKIVE.Helpers.isDesygnerProject()) {
      INKIVE.Helpers.displaySubscriptionModal('tool.versions.helper.description');
      return;
    }

    INKIVE.Helpers.displaySubscriptionModal(null, 'content2');
  };

  isProUser = () => {
    const isWorkspace = !INKIVE.Helpers.isDesygnerProject();
    const workspaceAllowsUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');
    const isProPaidUser = INKIVE.UserInfoFactory.isProPaidUser();
    const isWorkspaceUser = INKIVE.UserInfoFactory.isBusinessUser();
    const isWorkspaceAllowed = isWorkspace && isWorkspaceUser;
    const hasContentPlan = INKIVE.UserInfoFactory.hasContentPlan();

    if (!hasContentPlan && workspaceAllowsUpselling) return false;

    return (isProPaidUser || isWorkspaceAllowed);
  };

  mapProps () {
    const bucket = INKIVE.C.BUCKET;
    const isProUser = useMemo(this.isProUser, []);

    return {
      ...this.#defaultOptions,
      isProUser,
      showProUserPaywall: this.showProUserPaywall,
      onGenerateQRCodeEvent: this.generateQRCode,
      bucketName: bucket,
      companionUrl: INKIVE.C.uppy_companion_url,
      objectKey: `${bucket.split('.').shift()}/company/qrcode/original`,
      waterMarkUrl: 'https://static.desygner.com/assets/img/logo-desygner-watermark.png'
    };
  }

  App = () => {
    const props = this.mapProps();

    return <QRCode {...props} />;
  };
}

export default new QRCodeView({
  appId: 'react-qrcode-app',
  targetNodeSelector: '#tabQRCode.tab .qrcode-app'
});
